<template>
  <span v-show='cpntMostrar' :id='cpntId' class="rf-icone">
    <template v-if='cpntIcone === "erro"'>
      <i class="far fa-times-circle" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "alerta"'>
      <i class="fa fa-exclamation-triangle" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "loadding"'>
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "cancelar"'>
      <i class="fa fa-times" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "editar"'>
      <i class="fa fa-pencil-alt" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "modificar"'>
      <i class="fa fa-retweet" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "excluir"'>
      <i class="fa fa-trash" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "reativar"'>
      <i class="fa fa-level-up-alt"  :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "check-circulo"'>
      <i class="far fa-check-circle" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "check-verde"'>
      <img src="/img/icones/check_verde.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "ico-mais"'>
      <i class="fa fa-plus" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "info"'>
      <i class="fas fa-info" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "trocar"'>
      <i class="fas fa-exchange-alt" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "calendario"'>
      <i class="far fa-calendar-alt" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "grafico"'>
      <i class="fas fa-chart-pie" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "grafico-2"'>
      <i class="far fa-chart-bar" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "pet"'>
      <i class="fas fa-paw" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "produto"'>
      <i class="fas fa-tags" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "servico"'>
      <i class="fas fa-wrench" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "veiculo"'>
      <i class="fas fa-car" :class='cpntIconeClass'></i>
    </template>
    <template v-else-if='cpntIcone === "atualizar"'>
      <i class="fas fa-redo-alt" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "ico-menos"'>
      <i class="fa fa-minus" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "xml"'>
      <i class="far fa-file-code" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "xml-2"'>
      <img src="/img/icones/xmlIcon.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "arquivo"'>
      <i class="far fa-file-alt" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "danfe"'>
      <i class="far fa-file-pdf" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "cce"'>
      <i class="far fa-envelope" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "nota-fiscal"'>
      <img src="/img/geral/doc_fiscais.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "salvar"'>
      <i class="far fa-save" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "filtro"'>
      <i class="fas fa-filter" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "pacotes"'>
      <i class="fas fa-box-open" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "insumo"'>
      <i class="fas fa-industry" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "cod_barras"'>
      <i class="fas fa-barcode" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "emitir"'>
      <i class="fa fa-angle-right" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "reemitir"'>
      <i class="fa fa-redo-alt" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "falha"'>
      <i class="fa fa-retweet" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "financeiro_pdv"'>
      <img src="/img/geral/fin.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "financeiro"'>
      <i class="fa fa-dollar-sign" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "agendamento"'>
      <i class="far fa-clock" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "pdv"'>
      <img src="/img/geral/pdv.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "anexo"'>
      <i class="fas fa-paperclip" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "copiar"'>
      <i class="far fa-copy" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "copiar-01"'>
      <i class="far fa-clipboard" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "reenviar"'>
      <i class="fa fa-paper-plane" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "lupa"'>
      <i class="fa fa-search" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "impressora"'>
      <i class="fa fa-print" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "busca-ws"'>
      <i class="fab fa-searchengin" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "quadrado"'>
      <img src="/img/geral/credev.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "circle-left"'>
      <i class="far fa-arrow-alt-circle-left" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "circle-right"'>
      <i class="far fa-arrow-alt-circle-right" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "sync"'>
      <i class="fas fa-sync" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "sair"'>
      <i class="fa fa-power-off" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "inicio"'>
      <i class="fas fa-home" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "start"'>
      <i class="fas fa-play" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "cliente"'>
      <i class="fas fa-male" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "venda"'>
      <i class="fas fa-cart-arrow-down" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "venda-01"'>
      <i class="fas fa-chart-line" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "venda-02"'>
      <img src="/img/menu/13.1.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "mesas"'>
      <i class="fas fa-table" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "sexo_mas"'>
      <i class="fas fa-mars" style="color: #2f5ffd;" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "sexo_fem"'>
      <i class="fas fa-venus" style="color: #ff2ca8" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "entrega"'>
      <i class="fas fa-motorcycle" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "whatsapp"'>
      <i class="fab fa-whatsapp" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "renomear"'>
      <i class="fas fa-pencil-alt" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "novo-comentario"'>
      <i class="far fa-comment-dots" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "cms"'>
      <img src="/img/geral/cms.png" :class='cpntIconeClass' />
    </template>
    <template v-else-if='cpntIcone === "sino-desativa"'>
      <i class="fa fa-bell-slash" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "chat"'>
      <i class="far fa-comment-dots" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "bd"'>
      <i class="fas fa-database" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "historico"'>
      <i class="fas fa-history" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else-if='cpntIcone === "pesquisa"'>
      <i class="fa fa-search" :class='cpntIconeClass' aria-hidden="true"></i>
    </template>
    <template v-else>
      <i :class="cpntIcone" aria-hidden="true"></i>
    </template>
  </span>
</template>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'icones-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntIcone: {
        required: true,
        type: String
      },
      cpntIconeClass: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntExplica: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      }
    },
    data: function () {
      return {
        tipoImg: [ 'financeiro_pdv', 'quadrado', 'pdv', 'nota-fiscal', 'cms' ]
      }
    },
    mounted: function () {
      this.cpntIconesIniciar()
    },
    destroyed: function () {
      // SETA O NOME DO CAMPO QUE DEVE APLICAR
      var element = '#' + this.cpntId + ' > '
      
      // VERIFICA SE É UM ICONE OU UMA IMAGEM
      element += (this.tipoImg.indexOf(this.cpntIcone) === -1 ? 'svg' : 'img')
      
      // DESTROY O QTIP SE ELE EXISTIR
      $(element).qtip('destroy');
    },
    methods: {
      cpntIconesIniciar: function () {
        this.cpntIconesCriarQtip()
      },
      cpntIconesCriarQtip: function () {
        if (this.cpntExplica !== null && this.cpntExplica !== undefined && Object.keys(this.cpntExplica).length >= 1) {
          // SETA AS CHAVES INICIAIS
          var chaves = {
            mensagem: '',
            titulo: '',
            posicaoMy: 'top left',
            posicaoAt: 'bottom right',
            classes: 'rf-qtip cpnt-qtip-icones ' + this.cpntExplica.class
          }

          // SETA OS VALOORE E PADROES PARA O QTIP
          for (var indexC in chaves) {
            this.cpntExplica[indexC] = [ '', null, undefined ].indexOf(this.cpntExplica[indexC]) !== -1 ? chaves[indexC] : this.cpntExplica[indexC]
          }

          // VERIFICA SE TEM QUE CONVERTER A CHAVE MESSAGE
          if (typeof this.cpntExplica.mensagem !== 'string' && this.cpntExplica.mensagem.length >= 1) {
            this.cpntExplica.mensagem = this.cpntExplica.mensagem.join('<br/>')
          }

          // AGUARDA O CARREGAMENTO DO CAMPO PARA SETAR O QTIP
          setTimeout(() => {
            // SETA O NOME DO CAMPO QUE DEVE APLICAR
            var element = '#' + this.cpntId + ' > '
            
            // VERIFICA SE É UM ICONE OU UMA IMAGEM
            element += (this.tipoImg.indexOf(this.cpntIcone) === -1 ? 'svg' : 'img')

            // APLICA O QTIP NO CAMPO DESEJADO
            $(element).qtip({
              content: {
                text: this.cpntExplica.mensagem,
                title: this.cpntExplica.titulo
              },
              position: {
                my: this.cpntExplica.posicaoMy,
                at: this.cpntExplica.posicaoAt
              },
              style: { classes: this.cpntExplica.classes }
            })
          }, 300)
        }
      }
    },
    watch: {
      cpntExplica: function () {
        this.cpntIconesCriarQtip()
      }
    }
  }
</script>
